import * as React from 'react';

import {CrossBrowserHiddenFormSubmit} from 'shells/form/cross-browser-hidden-form-submit';
import {Label} from 'shells/form/label';

import type {
    AccountTypeAutomation as AccountTypeAutomationFragment,
    AccountType as AccountTypeFragment,
} from 'nutshell-graphql-types';

import {GraphQLSelectAccountTypes} from '../../../core/select/graphql-select-account-types';
import {SalesAutomationSidebarFormWrapper} from '../../../core/sidebar/sales-automation-sidebar-form-wrapper';

import styles from '../sales-process-form.module.css';

type Props = {
    entity: AccountTypeAutomationFragment | null | undefined;
    formSubmitBtnRef: (arg1?: HTMLInputElement | null | undefined) => void;
    onDelete: () => Promise<any>;
    onSaveForm: (arg1: string) => Promise<any>;
    canAccessSetup: boolean;
};

type State = {
    currentAccountTypeId: string | null | undefined;
};

export class FormAccountAssignmentsComponent extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            currentAccountTypeId: getInitialSelectionFromProps(props),
        };
    }

    render() {
        return (
            <SalesAutomationSidebarFormWrapper
                id={this.props.entity ? this.props.entity.id : null}
                onSaveForm={this.saveForm}
                onDelete={{
                    deleteText: 'Remove company assignment',
                    deleteConfirmationTitle:
                        'Are you sure you want to remove this company assignment?',
                    onDeleteConfirm: this.handleDeleteConfirm,
                }}
            >
                <div className={styles['form-input']}>
                    <Label htmlFor='AccountTypePicker'>
                        Companies related to this lead should have their company type changed to…
                    </Label>
                    <GraphQLSelectAccountTypes
                        // @ts-expect-error
                        labelId='AccountTypePicker'
                        onChange={this.handleAccountTypeChange}
                        selectedId={this.state.currentAccountTypeId}
                        defaultsToFirstItem={true}
                        isSearchable={false}
                        hasManageOption={this.props.canAccessSetup}
                    />
                </div>
                <CrossBrowserHiddenFormSubmit inputRef={this.props.formSubmitBtnRef} />
            </SalesAutomationSidebarFormWrapper>
        );
    }

    handleAccountTypeChange = (newAccountType: AccountTypeFragment) => {
        this.setState({
            currentAccountTypeId: newAccountType.id,
        });
    };

    handleDeleteConfirm = () => {
        return this.props.onDelete();
    };

    saveForm = (): Promise<any> | null | undefined => {
        if (this.state.currentAccountTypeId) {
            return this.props.onSaveForm(this.state.currentAccountTypeId);
        }
    };
}

function getInitialSelectionFromProps(props: Props): string | null | undefined {
    if (props.entity) {
        return props.entity.accountType.id;
    }

    return null;
}
